import { Component, Fragment, h } from "preact";
import Vouchers from "../../../../services/vouchers";
import { Trans } from "@lingui/react/macro";
import { formatDateTime } from "../../utils/date-formats";
import formatCurrency from "../../../../services/currency";
import Config from "../../../../services/config";

import * as U from "../../desktop-templates/menu-user";
import { route } from "preact-router";

export class VouchersPage extends Component {
    state = {
        loading: true,
        /**
         * @type {import("../../../../services/vouchers").Voucher[] | null}
         */
        allVouchers: null
    }
    vouchersService = new Vouchers();

    componentWillMount() {
        this.vouchersService.listActiveVouchers().then(vouchers => {
            this.setState({ loading: false, allVouchers: vouchers })
        }).catch(console.error)
    }

    /**
     * @param {import("../../../../services/vouchers").Voucher} voucher
     */
    cancelVoucher(voucher) {
        if (confirm("Do you want to cancel this voucher?"))
            this.vouchersService.redeemVoucher(voucher.id);
    }

    render() {
        return <div>
            <div class="overflow-x-auto user-menu-subnav">
                <U.SubTabsContainer>
                    <U.Tab selected={true}><Trans>Vouchers List</Trans></U.Tab>
                    <U.Tab onClick={e => { route("/user/payment-gateway/deposit") }}><Trans>Deposit</Trans></U.Tab>
                    <U.Tab onClick={e => { route("/user/payment-gateway/withdraw") }}><Trans>Withdraw</Trans></U.Tab>
                </U.SubTabsContainer>
            </div>
            <div class="user-menu-header main-text-color px-2 py-1 text-base font-bold ml-3 mt-2 capitalize"><Trans>Vouchers</Trans></div>
            <VouchersLists allVouchers={this.state.allVouchers} vouchersService={this.vouchersService} />
        </div>
    }
}

export class VouchersLists extends Component {
    /**
     * @param {import("../../../../services/vouchers").Voucher} voucher
     */
    cancelVoucher(voucher) {
        if (confirm("Do you want to cancel this voucher?"))
            this.props.vouchersService.redeemVoucher(voucher.id);
    }

    render({allVouchers, vouchersService}) {
        return <Fragment>
            <div class="main-text-color p-2 text-base">
                {!allVouchers ? null : <>
                    <Trans>Active vouchers</Trans>
                    <div>
                        {allVouchers.filter(v => v.redeemed_time == null).map(voucher => (<div class="px-4 py-2 w-full bg-slate-200 border border-slate-300 flex flex-wrap gap-2 items-center justify-between">
                            <div class=""><span class="text-slate-600 text-sm">Id:</span> <span>{voucher.id}</span> {voucher.approved ? null : <span class="bg-red-500 text-white text-xs px-1 py-0.5">PENDING</span>}</div>
                            <div class=""><span class="text-slate-600 text-sm">Created:</span> <span>{formatDateTime(new Date(voucher.created_time * 1000))}</span></div>
                            <div class=""><span class="text-slate-600 text-sm">Amount:</span> <span>{formatCurrency(voucher.amount, voucher.currency)} {Config.currencySymbol}</span></div>
                            <div class=""><button class="w-full px-2 py-1 bg-red-600 rounded text-white" onClick={e => this.cancelVoucher(voucher)}><Trans>Cancel</Trans></button></div>
                        </div>))}
                    </div>
                </>}
            </div>
            <div class="main-text-color p-2 text-base">
                {!allVouchers ? null : <>
                    <Trans>Expired vouchers</Trans>
                    <div>
                        {allVouchers.filter(v => v.redeemed_time != null).map(voucher => (<div class="px-4 py-2 w-full bg-slate-200 border border-slate-300 flex flex-wrap gap-2 items-center justify-between">
                            <div class="w-1/3 grow shrink"><span class="text-slate-600 text-sm">Id:</span> <span>{voucher.id}</span></div>
                            <div class="w-1/3 grow shrink"><span class="text-slate-600 text-sm">Created:</span> <span>{formatDateTime(new Date(voucher.created_time * 1000))}</span></div>
                            <div class="w-1/3 grow shrink"><span class="text-slate-600 text-sm">Amount:</span> <span>{formatCurrency(voucher.amount, voucher.currency)} {Config.currencySymbol}</span></div>
                            <div class="w-1/3 grow shrink">
                                <div><span class="text-slate-600 text-sm">Redeemed by:</span> <span>{voucher.redeemed_account}</span></div>
                                <div><span class="text-slate-600 text-sm">at:</span> <span>{formatDateTime(new Date(voucher.redeemed_time * 1000))}</span></div>
                            </div>
                        </div>))}
                    </div>
                </>}
            </div>
        </Fragment>
    }
}